(() => {
  'use strict';
  if (window.lmbBespokeLinksLoaded) return;
  window.lmbBespokeLinksLoaded = true;
  if (!window.Shopify?.theme || String(Shopify.theme.role).toLowerCase() === 'main') return;
  const landing = `/collections/made-to-order-range?preview_theme_id=${Shopify.theme.id}`;
  document.querySelectorAll('[data-bespoke-nav]').forEach(link => { link.href = landing; });
  const links = document.querySelectorAll('[data-bespoke-promo]');
  const source = document.querySelector('[data-bespoke-catalogue-url]');
  if (!links.length || !source) return;
  fetch(source.dataset.bespokeCatalogueUrl).then(response => { if (!response.ok) throw new Error('Bespoke links unavailable'); return response.json(); }).then(catalogue => {
    links.forEach(link => {
      const range = catalogue.ranges.find(item => item.key === link.dataset.bespokePromo);
      if (!range?.previewUrl) return;
      const original = new URL(range.previewUrl);
      const url = new URL(original.pathname + original.search, location.origin);
      url.searchParams.set('preview_theme_id', Shopify.theme.id); link.href = url.href;
    });
  }).catch(error => console.error(error));
})();
